<mat-card class="default-card grid-all">
    <mat-card-header>
        <mat-card-title>{{ title }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <form class="form-container" #dialogForm="ngForm">
                <div class="form-container">
                    <div class="form-item">
                        <mat-form-field>
                            <mat-label>Nom de la variable</mat-label>
                            <input matInput type="text" [(ngModel)]="item.name" name="variableName" required autocomplete="false" tabindex="1" />
                        </mat-form-field>
                    </div>
                    <div class="form-item">
                        <mat-form-field>
                            <mat-label>Type de variable</mat-label>
                            <mat-select [(ngModel)]="item.type" name="variableType" tabindex="2">
                                @for (variableType of variableTypes | keyvalue; track variableType.key) {
                                    <mat-option [value]="variableType.key">
                                        {{ variableType.value }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="form-item">
                        <mat-form-field>
                            <mat-label>Valeur de la variable</mat-label>
                            <input matInput type="text" [(ngModel)]="item.value" name="variableValue" required autocomplete="false" tabindex="3" />
                        </mat-form-field>
                    </div>
                </div>
            </form>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="onCancel()">Annuler</button>
        <button mat-raised-button class="accent-button" (click)="onConfirm()">Valider</button>
    </mat-card-actions>
</mat-card>
